module.exports = __webpack_public_path__ + "img/agpz-bus-default.37130aa1.svg";